export default __webpack_public_path__ + "chevron-ring-fill.e0edcd9cda4074ad.svg";